import { render } from "./A106000Dialog.vue?vue&type=template&id=0e12872e&scoped=true"
import script from "./A106000Dialog.vue?vue&type=script&lang=js"
export * from "./A106000Dialog.vue?vue&type=script&lang=js"

import "./A106000Dialog.vue?vue&type=style&index=0&id=0e12872e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e12872e"]])

export default __exports__